import $http from '../../axios';
import {MessageBox, Notification} from 'element-ui';
import moment from 'moment';

export async function downloadAccountingDocument({}, documentToPdf) {
  let name = documentToPdf.vouchertype.name_voucher_type + ' No. ' + documentToPdf.consecutive + '.pdf'
  await $http({
    url: '/api/descargar-pdf-contabilidad/'+documentToPdf.id,
    method: 'GET',
    responseType: 'blob',
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', name);
    document.body.appendChild(link);
    link.click();
  }).catch((error) => {
    Notification.error({
      title: 'Error!',
      message: error.message,
      type: 'error',
      duration: 3000,
      customClass: 'notification-box',
    });

  })
}
export async function downloadPdfInventory({state}, document_id) {

    let name = state.pdf_document_name;
    state.pdf_clear_params = false;
  await $http({
    url: '/api/documentos/descargar-pdf/'+ document_id,
    method: 'GET',
    responseType: 'blob',
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    state.file_name = '/storage/pdf/'+name ;
    state.show_pdf = true ;
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', name);
    document.body.appendChild(link);
    link.click();
  }).catch((error) => {
    Notification.error({
      title: 'Error!',
      message: error.message,
      type: 'error',
      duration: 3000,
      customClass: 'notification-box',
    });

  })
}


//recontabilizar documento
export async function accountingDoc({commit, state, dispatch}, document_id){
  await $http.get(`/api/documento/contabilizar/${document_id}`)
  .then(response => {
    dispatch('listTransactions', document_id);
  })
  .catch(error => {
    let data = error.response.data
    Notification.error({
      title: "Error!",
      message: data.message,
      type: "error",
      duration: 4500,
      customClass: "notification-box"
    });
  });
}

export async function listTransactions({commit, state, dispatch}, document_id) {
    await $http.get(`/api/comprobantes-documento/${document_id}`)
        .then(async response => {
            commit('listTransactions', response.data.data);
            await dispatch('fetchBalanceByContacts');
        })
        .catch(error => {
            // let data = error.response.data
            Notification.error({
                title: 'Error!',
                message: 'error',
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

//Obtener las sedes
export async function fetchBranchOffices({commit, state}) {
    await $http.get('/api/sedes')
      .then((response) => {
        commit('setBranchOffices', response.data)
      })
      .catch((error) => {
        Notification.error({
          title: 'Error!',
          message: error.message,
          type: 'error',
          duration: 2000,
          customClass: 'notification-box',
        });
        commit('BranchOfficeError', error.message)
      })
  }

export async function fetchVouchertype({commit, state}) {
    await $http.get('/api/tipos-de-comprobantes', { params : state.paramsVoucherType})
        .then((response) => {
            commit('setVouchersTypes', response.data.data)
        })
        .catch((error) => {
            Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 2000,
            customClass: 'notification-box',
        });
    })
}

export async function fetchpayment_methods(
  { commit, state },
) {
  await $http
    .get("/api/parametros-por-tabla/111")
    .then(response => {
      commit("setpayment_methods", response.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
      commit("modelError", error.message);
    });
}

export async function getcommissionable_concepts(
  { commit, state },
) {
  await $http
    .get("/api/parametros-por-tabla/115")
    .then(response => {
      commit("setcommissionable_concepts", response.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
      commit("modelError", error.message);
    });
}
export async function fetchGroups(
    { commit, state },
  ) {
    await $http
      .get("/api/parametros-por-tabla/97")
      .then(response => {
        commit("setGroups", response.data);
      })
      .catch(error => {
        Notification.error({
          title: "Error!",
          message: error.message,
          type: "error",
          duration: 1500,
          customClass: "notification-box"
        });
        commit("modelError", error.message);
      });
  }
  export async function fetchContacts({commit,state}, requestParameters = {params: state.paramsquery}) {
    await $http.get('/api/terceros', requestParameters)
        .then((response) => {
            commit('setContacts', response.data.data.data)
        })
        .catch((error) => {
            Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 1500,
            customClass: 'notification-box',
        });
    })
  }

export async function fetchTemplates({commit, state}) {
    await $http.get('/api/modelos', { params : state.paramstemplates})
        .then((response) => {
            commit('setTemplates', response.data.data.data)
        })
        .catch((error) => {
            Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 2000,
            customClass: 'notification-box',
        });
    })
}
export async function fetchcost_center_1(
    { commit, state },
  ) {
    await $http
      .get("/api/parametros-por-tabla/9")
      .then(response => {
        commit("setcost_center_1", response.data);
      })
      .catch(error => {
        Notification.error({
          title: "Error!",
          message: error.message,
          type: "error",
          duration: 1500,
          customClass: "notification-box"
        });
        commit("modelError", error.message);
      });
  }

export async function fetchCities({commit, state}, text) {
    let params = { department:state.params.departament, filter:text}
    await $http.get('/api/ciudades-departamentos', {params} )
        .then((response) => {
            commit('setCities', response.data.data)

        })
        .catch((error) => {
            Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 1500,
            customClass: 'notification-box',
        });
    })
}
export async function fetchsellers({commit, state}, text) {
    let params = { filter:text}
    await $http.get('/api/lista-vendedores', {params} )
        .then((response) => {
            commit('setSellers', response.data.data)

        })
        .catch((error) => {
            Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 1500,
            customClass: 'notification-box',
        });
    })
}
export async function fetchProjects({commit, state}, text) {
    let params = { filter:text, status:1, paginate: false,}
    await $http.get('/api/proyectos', {params} )
        .then((response) => {
            commit('setProjects', response.data.data)

        })
        .catch((error) => {
            Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 1500,
            customClass: 'notification-box',
        });
    })
}
export async function fetchProjectsdt({commit, state}, text) {
    let params = { filter:text, status:1, paginate: false,}
    await $http.get('/api/proyectos-activos', {params} )
        .then((response) => {
            commit('setProjectsdt', response.data.data)

        })
        .catch((error) => {
            Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 1500,
            customClass: 'notification-box',
        });
    })
}
export async function fetchconsecutive({commit, state}, data) {
  await $http.get('/api/tipos-de-comprobantes/'+data.voucherType_id, {params:data})
      .then((response) => {
        commit('setConsecutive', response.data.data)
      })
      .catch((error) => {
          Notification.error({
          title: 'Error!',
          message: error.message,
          type: 'error',
          duration: 1500,
          customClass: 'notification-box',
      });
  })
}

export async function fetchContact({commit,state}, id) {
  await $http.get('/api/terceros/'+id)
      .then((response) => {
          commit('setContacts', [response.data.data])
      })
      .catch((error) => {
          Notification.error({
          title: 'Error!',
          message: error.message,
          type: 'error',
          duration: 1500,
          customClass: 'notification-box',
      });
  })
}

export async function fetchContactAudit({commit,state}, document) {
  commit('setContactsAudit', document);
}

export async function fetchContactdt({commit,state}, id) {
  await $http.get('/api/terceros/'+id)
      .then((response) => {
          commit('setContactdt', response.data.data)
      })
      .catch((error) => {
          Notification.error({
          title: 'Error!',
          message: error.message,
          type: 'error',
          duration: 1500,
          customClass: 'notification-box',
      });
  })
}

/**
 * Buscar documento.
 */
export async function findDocument({commit,state}) {

    let params = {
        affects_prefix_document: state.params.affects_prefix_document ? state.params.affects_prefix_document.toUpperCase() : '',
        affects_number_document: state.params.affects_number_document,
        in_progress: false,
        contact_id: state.params.contact_id,
        origin_document: true
    }

    await $http.get('/api/buscar-documento-filtros', {params})
        .then((response) => {
            commit('setShowToModalAlert', true)
            commit('setOldDocument', response.data.data)
        })
        .catch((error) => {
            commit('setOldDocument', {})
        })
}

export async function downloadDocument({state}) {

    let name = state.old_document.prefix.trim() + '-' + state.old_document.consecutive;
    await $http({
        url: '/api/documentos/descargar-pdf/' + state.old_document.id,
        method: 'GET',
        responseType: 'blob',
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name + '.pdf');
        document.body.appendChild(link);
        link.click();
    }).catch((error) => {
        Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 3000,
            customClass: 'notification-box',
        });

    })
}

/**
 * Clonar documento
 */
export async function cloneAccountingDocument({commit, state, dispatch}) {
    const payload = {
        branchoffice_id: state.params.branchoffice_id,
        contact_id: state.params.contact_id ,
        vouchertype_id: state.params.voucherType_id,
        document_id: state.params.original_document ? state.params.original_document.id : null
    }

    await $http.post('/api/clonar-documento-contable/', payload)
        .then(async (response) => {
            commit("setParamsClone", response.data.data);
            await dispatch('fetchconsecutive', {
                voucherType_id: state.params.voucherType_id,
                template_id: null,
                branchoffice_id: state.params.branchoffice_id
            })
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.response.data,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
        })
}

/**
 * Copiar documento
 */
export async function copyAccountingDocument({commit, state, dispatch}) {
    const payload = {
        document_id: state.params.document_id
    }

    await $http.post('/api/copiar-documento-contable/', payload)
        .then(async (response) => {
            commit("setParamsClone", response.data.data);
            commit('setEditDocument', false)
            await dispatch('fetchconsecutive', {
                voucherType_id: state.params.voucherType_id,
                template_id: null,
                branchoffice_id: state.params.branchoffice_id
            })
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.response.data,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
        })
}

export async function fetchContactsdt({commit,state}, requestParameters = {params: state.paramsquerydt}) {
  await $http.get('/api/terceros', requestParameters)
      .then((response) => {
          commit('setContactsdt', response.data.data.data)
      })
      .catch((error) => {
          Notification.error({
          title: 'Error!',
          message: error.message,
          type: 'error',
          duration: 1500,
          customClass: 'notification-box',
      });
  })
}

export async function fetchContacts_filterdt({commit,state}, requestParameters = {params: state.paramsquerydt}) {
  await $http.get('/api/terceros', requestParameters)
      .then((response) => {
          commit('setContacts_filterdt', response.data.data.data)
      })
      .catch((error) => {
          Notification.error({
          title: 'Error!',
          message: error.message,
          type: 'error',
          duration: 1500,
          customClass: 'notification-box',
      });
  })
}

//Obtener las sedes
export async function fetchBranchoffice({commit, state}, id) {
  await $http.get('/api/sedes/'+id)
    .then((response) => {
      commit('setbranchOffice', response.data.data)
    })
    .catch((error) => {
      Notification.error({
        title: 'Error!',
        message: error.message,
        type: 'error',
        duration: 2000,
        customClass: 'notification-box',
      });
      commit('BranchOfficeError', error.message)
    })
}

export async function createVariousVouchers({commit , state}){
  await $http.post('/api/comprobantes-varios', state.params)
  .then((response)=>{
    commit('setParamsdocumentid', response.data.data)
  })
  .catch((error)=>{
    Notification.error({
      title: 'Error!',
      message: error.message,
      type: 'error',
      duration: 2000,
      customClass: 'notification-box',
    });
  })
}

export async function fetchCancellationReasons(
  { commit, state },
) {
  await $http
    .get("/api/parametros-por-tabla/116")
    .then(response => {
      commit("setCancellationReasons", response.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
      commit("modelError", error.message);
    });
}

export async function cancelAccountingDocument({commit, state}){

  let params = {
    'cancellation_reason' : state.params.cancellation_reason,
    'observation'         : state.params.observation
  }

  await $http.put(`/api/documento-contable/cancelar/${state.params.document_id}`, params)
      .then((response) => {
        Notification.error({
          title: 'Exito!',
          message: response.data.message,
          type: 'success',
          duration: 1500,
          customClass: 'notification-box',
        });
      })
      .catch((error) => {
        let data = error.response.data
        Notification.error({
            title: 'Error!',
            message: data.message,
            type: 'error',
            duration: 1500,
            customClass: 'notification-box',
        });
  })

}

export async function fetchContactselect({commit, state}, id){
  let contats =[]
  await $http.get('/api/terceros/'+id)
      .then((response) => {
          contats= [response.data.data]
          // commit('setContactdt', response.data.data)
      })
      .catch((error) => {
          Notification.error({
          title: 'Error!',
          message: error.message,
          type: 'error',
          duration: 1500,
          customClass: 'notification-box',
      });
  })
  return contats
}

export async function fetchAccountFromRoot({commit, state}, id){
  let accounts =[]
  await $http
  .get(`/api/cuentas-raiz/${id}`)
  .then(response => {
    accounts = response.data.data
    // commit("setaccountsselect", );
  })
  .catch(error => {
    let data = error.response.data
    Notification.error({
      title: "Error!",
      message: data.message,
      type: "error",
      duration: 1500,
      customClass: "notification-box"
    });
  });
  return accounts
}

export async function fetchAccount({commit , state}, id){
  let account =[];
  await $http
  .get(`/api/cuentas/${id}`)
  .then(response => {
    account = response.data.data
    // commit("setaccountselect", response.data.data);
  })
  .catch(error => {
    let data = error.response.data
    Notification.error({
      title: "Error!",
      message: data.message,
      type: "error",
      duration: 1500,
      customClass: "notification-box"
    });
  });
  return account
}

export async function fetchVoucherInModels({commit , state}, id){
  let vouvherInModels =[];
  await $http
  .get(`/api/tipocomprobante-modelos/${id}`)
  .then(response => {
    vouvherInModels = response.data.data
    // commit("setaccountselect", response.data.data);
  })
  .catch(error => {
    let data = error.response.data
    Notification.error({
      title: "Error!",
      message: data.message,
      type: "error",
      duration: 1500,
      customClass: "notification-box"
    });
  });
  return vouvherInModels
}

export async function fetchTax({commit , state}, id){
  let tax =[];
  await $http
  .get(`/api/impuestos/${id}`)
  .then(response => {
    tax = response.data.data
  })
  .catch(error => {
    let data = error.response.data
    Notification.error({
      title: "Error!",
      message: data.message,
      type: "error",
      duration: 1500,
      customClass: "notification-box"
    });
  });
  return tax
}

export async function setTransactionsByCsv({commit , state, dispatch}, transactions){
  // setear en la variable transactions_csv las transacciones del csv
  state.params.transactions_csv = transactions
  await $http
  .post(`/api/transacciones-csv/`, state.params  )
  .then(async response => {
      commit('setParamsdocument_id', response.data.data)
      await dispatch('listTransactions', state.params.document_id);
  })
  .catch(error => {
    let errors = error.response.data.data;
    let csv = errors.join('\r\n');

    let now = new Date();
    let year = now.getFullYear();
    let month = String(now.getMonth() + 1).padStart(2, '0');
    let day = String(now.getDate()).padStart(2, '0');
    let hours = String(now.getHours()).padStart(2, '0');
    let minutes = String(now.getMinutes()).padStart(2, '0');
    let seconds = String(now.getSeconds()).padStart(2, '0');
    let date = `${year}${month}${day}${hours}${minutes}${seconds}`

    let link = document.createElement('a');
    link.id = 'download-csv'+date;
    link.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(csv));
    let file_name = 'errores'+date+'.csv';
    link.setAttribute('download', file_name);
    document.body.appendChild(link);
    document.querySelector('#download-csv'+date).click();

    Notification.error({
      title: "Error!",
      message: 'Error al crear transacciones',
      type: "error",
      duration: 1500,
      customClass: "notification-box"
    });
  });
}

export async function finalizeAccountingDocument({commit, state, dispatch}) {
    return new Promise(async (resolve, reject) => {
        await $http.post('/api/finalizar-documento-contable', state.params)
            .then((response) => {
                dispatch('accountingDocumentAttachment');
                commit('setShowPdf', response.data.data);
                resolve(false)
            })
            .catch((error) => {
                let data = error.response.data;

                Notification.error({
                    title: 'Error!',
                    message: data.message,
                    type: 'error',
                    duration: 1500,
                    customClass: 'notification-box'
                });

                if (data.message === 'Comprobante Descuadrado.') {
                    resolve(true)
                }else{
                  commit('setloading_form', false);
                }
            });
    });
}

export async function downloadFile({commit, state}, file){
  await $http({
    url: `/api/descargar-archivo`,
    params : file,
    method: 'GET',
    responseType: 'blob',
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', file.name);
    document.body.appendChild(link);
    link.click();
  }).catch((error) => {
    Notification.error({
      title: 'Error!',
      message: error.message,
      type: 'error',
      duration: 3000,
      customClass: 'notification-box',
    });

  })
  // await $http
  // .get()
  // .then(response => {
  //   // commit("setaccountselect", response.data.data);
  // })
  // .catch(error => {
  //   let data = error.response.data
  //   Notification.error({
  //     title: "Error!",
  //     message: data.message,
  //     type: "error",
  //     duration: 1500,
  //     customClass: "notification-box"
  //   });
  // });
}

export async function fetchFiles({commit, state}, document_id){
  await $http
  .get(`/api/archivos-documento/${document_id}`)
  .then(response => {
    commit('setFilesSearchDocument', response.data)
  })
  .catch(error => {
    let data = error.response.data
    Notification.error({
      title: "Error!",
      message: data.message,
      type: "error",
      duration: 1500,
      customClass: "notification-box"
    });
  });
}

export async function accountingDocumentAttachment({commit , state}){
  let formData = new FormData();

  formData.append("document_id", state.params.document_id);

  state.document_files_new.map(fn => {
    formData.append("filesUpload[]", fn);
  });

  state.document_files_delete.map(fn => {
    formData.append("filesDelete[]", JSON.stringify(fn));
  });

  await $http.post('/api/documento-contable-adjuntos', formData)
  .then((response)=>{
    commit('setFiles', response.data.data.data)
  })
  .catch((error)=>{
    Notification.error({
      title: 'Error!',
      message: error.message,
      type: 'error',
      duration: 2000,
      customClass: 'notification-box',
    });
  })
}

export async function fetchDocumentransactions({commit , state}, id){
  await $http
  .get(`/api/comprobantes-documento/${id}`)
  .then(response => {
    // commit("setaccountselect", response.data.data);
  })
  .catch(error => {
    let data = error.response.data
    Notification.error({
      title: "Error!",
      message: data.message,
      type: "error",
      duration: 1500,
      customClass: "notification-box"
    });
  });
}

export async function searchDocument({commit , state}, data){
  let requestParameters = {params: data}, docu
  await $http.get('/api/buscar-documento', requestParameters)
      .then((response) => {
          // commit('setContacts_filterdt', data)
          docu = response.data.data
      })
      .catch((error) => {
          Notification.error({
          title: 'Error!',
          message: error.message,
          type: 'error',
          duration: 1500,
          customClass: 'notification-box',
      });
  })
  return docu
}

export async function getDocument({commit , state}, document_id){
  let docu
  await $http.get(`/api/buscar-documento/${document_id}`)
      .then((response) => {
          // commit('setContacts_filterdt', data)
          docu = response.data.data
      })
      .catch((error) => {
          Notification.error({
          title: 'Error!',
          message: error.message,
          type: 'error',
          duration: 1500,
          customClass: 'notification-box',
      });
  })
  return docu
}

export async function editDocument({commit , state}, id){
  await $http
  .get(`/api/editar-documento/${id}`)
  .then(response => {
    commit("setParamsEdit", response.data.data);
  })
  .catch(error => {
      console.error(error);
    let data = error.response.data
    Notification.error({
      title: "Error!",
      message: data.message,
      type: "error",
      duration: 1500,
      customClass: "notification-box"
    });
  });
}

export async function FinalizeUpdate({commit, state, dispatch}, id) {
    return new Promise(async (resolve, reject) => {
        state.params.total_debit = state.total_debit;
        state.params.total_credit = state.total_credit;
        await $http
            .post(`/api/actualizar-documento-contable`, state.params)
            .then(response => {
                dispatch('accountingDocumentAttachment');
                commit('setShowPdf', response.data.data);
                resolve(false);
            })
            .catch(error => {
                let data = error.response.data;
                Notification.error({
                    title: 'Error!',
                    message: data.message,
                    type: 'error',
                    duration: 1500,
                    customClass: 'notification-box'
                });

                if (data.message === 'Comprobante Descuadrado.') {
                    resolve(true);
                }
            });
    });
}

export async function deleteAccountFromDocumentTransaction({commit, state}, $id){
  await $http
  .delete(`/api/eliminar-partida/${$id}`)
  .then(response => {
    // commit('setShowPdf', response.data.data)
  })
  .catch(error => {
    let data = error.response.data
    Notification.error({
      title: "Error!",
      message: data.message,
      type: "error",
      duration: 1500,
      customClass: "notification-box"
    });
  });
}

export async function getAuditDocument({ commit, state },id_document) {

  await $http
    .get("/api/auditoria-documento-modulo/"+id_document)
    .then(response => {
      commit("setAudit", response.data.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}
export async function getSubscriber({commit, dispatch, state}) {
  await $http.get(`/api/suscriptor`)
  .then(response => {
      commit('setSubscriber', response.data.data);
  })
  .catch(error => {
      console.error(error);
  });
}
export async function fetchCorrerias({ commit, state }) {
    await $http
        .get('/api/parametros-por-codigo/039')
        .then(response => {
            commit('setCorrerias', response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

export async function fetchBalanceByContact({commit, state}, document_transaction) {
    return new Promise(async (resolve, reject) => {
        const year_month = moment().format('YYYYMM');

        const params = {
            year_month_from: year_month,
            year_month_up: year_month,
            account_id: document_transaction.account_id,
            contact_id: document_transaction.contact_id
        };

        await $http
            .get('/api/reporte-balance-tercero', {params})
            .then(response => {
                if (response.data && response.data.data && response.data.data[0]){
                    resolve(response.data.data[0].final_balance)
                }else{
                    resolve(0);
                }
            })
            .catch(error => {
               reject();
            });
    });
}

export async function fetchBalanceByContacts({commit, state}) {
    const year_month = moment().format('YYYYMM');

    const data = {
        data : []
    };

    state.params.document_transactions.map(dt => {
        if (dt.contact_id && dt.account_id && !data.data.find(i => i.contact_id === dt.contact_id && i.account_id === dt.account_id)) {
            data.data.push({
                year_month_from: year_month,
                year_month_up: year_month,
                account_id: dt.account_id,
                contact_id: dt.contact_id
            });
        }
    });

    await $http
        .post('/api/reporte-balance-terceros', data)
        .then(response => {
            response.data;
            commit('setBalancesByContacts', response.data.data);
        })
        .catch(error => {
            commit('setBalancesByContacts', []);
        });
}

export async function getContactById({commit, state}, id) {
    return new Promise(async (resolve, reject) => {
        await $http
            .get('/api/terceros/' + id)
            .then(response => {
                resolve(response.data.data)
            })
            .catch(error => {
                reject();
            });
    });
}

export async function validateCrossDocument ({commit, state}){
  let params= {
    'contact_id': state.params.contact_id,
    'vouchertype_id': state.params.voucherType_id,
    'affects_prefix_document': state.params.affects_prefix_document,
    'affects_number_document': state.params.affects_number_document,
  }

  let validate;

  await $http
  .get("/api/validar-doc-cruce", {params})
  .then(response => {
    validate = response.data;
  })
  .catch(error => {
    Notification.error({
      title: "¡Error!",
      message: error.response.data.message,
      type: "error",
      duration: 1500,
      customClass: "notification-box"
    });
  });

  return validate;
}



// WEBPACK FOOTER //
// ./src/modules/various-vouchers/actions.js